import { useAToast } from '@Atoms';
import { AddSelectedAnimalsService } from '../../KennelManager/services';
import type { AddSelectedAnimalsPayload } from '../../KennelManager/types/kennel.types';

const { notify, TOAST_TYPES } = useAToast();

const TOAST_ERROR = {
  message: 'errors.generics.unknownIssue.message',
  title: 'errors.generics.unknownIssue.title',
  type: TOAST_TYPES.ERROR,
};

async function onAddAnimalOnKennel(payload: AddSelectedAnimalsPayload) {
  const PAYLOAD = payload;

  await AddSelectedAnimalsService(PAYLOAD).catch(() => notify(TOAST_ERROR));
}
export default { onAddAnimalOnKennel };
